import firebaseLib from "firebase/app";
import "firebase/database";
import "firebase/auth";
import "firebase/storage";

import api from "src/assets/config/api";
import _ from "lodash";
let auth;
let db;

const firebaseConfig = {
  apiKey: process.env.PROD_VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.PROD_VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.PROD_VUE_APP_DATABASE_URL,
  projectId: process.env.PROD_VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.PROD_VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.PROD_VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.PROD_VUE_APP_FIREBASE_APP_ID
};

const configuredAppForReportBug = (config) => {
  if (!firebaseLib.apps.length) {
    firebaseLib.initializeApp(config || firebaseConfig);
  }
  return firebaseLib.apps[0];
};

const checkAlreadyConfiguredApp = () => {
  return firebaseLib.apps[0];
};

const configureFirebase = async config => {
  try {
    firebaseLib.initializeApp(config);
    auth = firebaseLib.auth();
    db = firebaseLib.database();

    return { message: "Firebase configured successfully" };
  } catch (e) {
    throw e;
  }
};

const unconfigureFirebase = () => {
  return firebaseLib.apps[0].delete();
};

const login = async credentials => {
  try {
    const loginResponse = await firebaseLib
      .auth()
      .signInWithEmailAndPassword(credentials.email, credentials.password);

    const dbResponse = await readDatabase(`users/${loginResponse.user.uid}`);

    return dbResponse;
  } catch (e) {
    throw e;
  }
};

const readDatabase = async path => {
  try {
    const response = await firebaseLib
      .database()
      .ref(path)
      .once("value");

    return { key: response.key, data: response.val() };
  } catch (e) {
    throw e;
  }
};

const updateDatabase = async (path, data) => {
  return firebaseLib
    .database()
    .ref(path)
    .update(data);
};

const uploadImage = async (path, dataurl) => {
  try {
    const name = Math.random()
      .toString()
      .split(".")[1];
    const ref = firebaseLib.storage().ref(`${path}/${name}`);
    await ref.putString(dataurl, "data_url");
    const downloadURL = await ref.getDownloadURL();

    return downloadURL;
  } catch (e) {
    throw e;
  }
};
const pushDatabase = async (path, data) => {
  try {
    const newRef = firebaseLib.database().ref(path).push();
    await newRef.set(data);
    return {
      key: newRef.key,
      path: newRef.toString(),
      data,
    };
  } catch (error) {
    console.error("Error pushing data:", error);
    throw error;
  }
};
const reAuthenticateUserFirebase = c => {
  const user = firebaseLib.auth().currentUser;
  const credential = firebaseLib.auth.EmailAuthProvider.credential(
    c.email,
    c.password
  );

  return user.reauthenticateAndRetrieveDataWithCredential(credential);
};

const updatePasswordFirebase = newPassword => {
  const user = firebaseLib.auth().currentUser;

  return user.updatePassword(newPassword);
};

const logout = () => {
  return firebaseLib.auth().signOut();
};
const updateUserActiveStatus = async (status, userId) => {
  try {
    await firebaseLib.database().ref(`users/${userId}`).update({ isActive : status });
  } catch (error) {
    console.error("Error updating status:", error);
    swal("Oops!", "Failed to update status", "error");
  }
}
const createOrUpdateQuarterlyMeetingDetails = async (details, userId) => {
  try {
    await firebaseLib.database().ref(`users/${userId}`).update({ nextQuarterlyMeetingDetails : details, nextQuarterlyMeeting: null });
  } catch (error) {
    console.error("Error updating quarterly meeting details:", error);
    swal("Oops!", "Failed to update quarterly meeting details", "error");
  }
}
const createOrUpdateIncrementMeetingDetails = async (details, userId) => {
  try {
    await firebaseLib.database().ref(`users/${userId}`).update({ nextIncrementMeetingDetails : details, nextIncrementReview: null });
  } catch (error) {
    console.error("Error updating increment meeting details:", error);
    swal("Oops!", "Failed to update increment meeting details", "error");
  }
}
const deleteQuarterlyMeetingDetails = async (userId) => {
  try {
    await firebaseLib
      .database()
      .ref(`users/${userId}`)
      .update({
        nextQuarterlyMeetingDetails: null,
        nextQuarterlyMeeting: null
      })
  } catch (error) {
    console.error("Error deleting quarterly meeting details:", error)
    swal("Oops!", "Failed to delete quarterly meeting details", "error")
  }
}
const deleteIncrementMeetingDetails = async (userId) => {
  try {
    await firebaseLib
      .database()
      .ref(`users/${userId}`)
      .update({
        nextIncrementMeetingDetails: null,
        nextIncrementReview: null
      })
  } catch (error) {
    console.error("Error deleting increment meeting details:", error)
    swal("Oops!", "Failed to delete increment meeting details", "error")
  }
}

const  updateUserStatus = async (status, userId)=> {
    try {
      await firebaseLib.database().ref(`users/${userId}`).update({ status});
    } catch (error) {
      throw new Error('Failed to update status: ' + error.message);
    }
  }
const  updateUserPreviousStatus = async(previousStatus, uid) =>{
  try {
     await firebaseLib.database().ref(`users/${uid}`).update({ previousStatus});
  }catch (error){
    throw new Error('Failed to update status: ' + error.message);
  }
}

const updateUserResignationDate = async (date, userId) =>{
    try {
      await firebaseLib.database().ref(`users/${userId}`).update({resignationDate:date});
    } catch (error) {
      throw new Error('Failed to update resignation date: ' + error.message);
    }
  }
const updateUserLeaves = async (userId, leavesData) => {
  try {
    await firebaseLib.database().ref(`users/${userId}`).update({
      leavesAllowed: leavesData.leavesAllowed,
      leavesTaken: leavesData.leavesTaken,
      leavesAvailable: leavesData.leavesAvailable,
    });
    return { message: "Leaves updated successfully" };
  } catch (error) {
    console.error("Error updating leaves: ", error);
    throw new Error("Failed to update leaves: " + error.message);
  }
};


const updateEmployee = async (data, userId) => {
  try {
    await firebaseLib.database().ref(`users/${userId}`).update(data);

  } catch (error) {
    console.error("Error updating employee: ", error);
    swal("Oops!", error.message, "error");
  }
};

const deletePromotionInfo = async (userId, index) => {
  try {
    const userRef = firebaseLib.database().ref(`users/${userId}`);
    const snapshot = await userRef.child('promotionInfo').once('value');
    const promotionInfo = snapshot.val() || [];

    promotionInfo.splice(index, 1);

    await userRef.child('promotionInfo').set(promotionInfo);

    console.log('Promotion info deleted successfully');
  } catch (error) {
    console.error('Error deleting promotion info:', error);
  }
}

const deleteEmployee = async (userId) => {
  try {
    await firebaseLib.database().ref(`users/${userId}`).remove(() => {
      swal("Great", "User Deleted Successfully", "success");
    });
  } catch (error) {
    console.error("Error deleting user: ", error);
    swal("Oops!", error.message, "error");
  }
};
const addEmployee = async (data) => {
  try {
    const newEmployeeRef = firebaseLib.database().ref('users').push();
    const userId = newEmployeeRef.key; 

    await newEmployeeRef.set({
      ...data,
      uid: userId, 
      createdAt: Date.now(),
    });

    swal("Great", "Employee added successfully", "success");

    return { uid: userId }; 
  } catch (error) {
    console.error("Error adding employee: ", error);
    swal("Oops!", error.message || "Failed to add employee", "error");
  }
};

const getEmailTemplates = async () => {
  try {
    const snapshot = await firebaseLib
      .database()
      .ref('constants/emailTemplates')
      .once('value');

    return snapshot.val() || {};
  } catch (error) {
    console.error("Error fetching templates:", error);
    return [];
  }
};

const addEmailTemplate = async (data) => {
  try {
    const templateRef = firebaseLib.database().ref('constants/emailTemplates').push();
    const templateId = templateRef.key;

    await templateRef.set({
      ...data,
      id: templateId,
      updatedAt: Date.now()
    });

    return { id: templateId };
  } catch (error) {
    console.error("Error saving email template: ", error);
    swal("Oops!", error.message || "Failed to save email template", "error");
  }
};

const updateEmailTemplate = async (templateId, data) => {
  try {
    await firebaseLib
      .database()
      .ref(`constants/emailTemplates/${templateId}`)
      .update({
        ...data,
        updatedAt: Date.now()
      });
  } catch (error) {
    console.error("Error updating email template: ", error);
    swal("Oops!", error.message || "Failed to update email template", "error");
  }
};

const fetchCompanyData = async(userEmail) =>{
  try {
    if (!userEmail) return;
    const response = await api.findCompanyByEmail(userEmail);
    const company = Array.isArray(response) && response.length > 0 ? response[0] : null;
    if (company) {
     return company
    }
  } catch (error) {
    console.error("Failed to fetch company data:", error);
  }
}
const fetchAllUsersRealTime = async () => {
  firebaseLib.database().ref("users").on("value", snapshot => {
    const usersData = snapshot.val();
    if (usersData) {
      const allUsers = Object.keys(usersData).map(userKey => ({
        ...usersData[userKey],
        uid: userKey,
      }));
      this.$store.commit("setAllUsers", allUsers);
    } else {
      console.log("No users data found.");
    }
  });
};


const submitLeave = async (path, data) => {
  try {   
    const res = await firebaseLib.database().ref(path).push(data);

    if (res) {
      return { message: "Leave submitted successfully", res };
    }
  } catch (error) {
    console.log("error agaaya bhai ", error);
  }
};


const getSingleUser = async (userId) => {
  try {
    const snapshot = await firebaseLib
      .database()
      .ref(`users/${userId}`)
      .once("value");
      
    if (snapshot.exists()) {
      return snapshot.val();
    } else {
      console.error("User not found:", userId);
      return null;
    }
  } catch (e) {
    console.error("Error fetching user data: ", e);
    throw e;
  }
};


const updateLeaveStatusAndComment = async (leaveId, status, userId, comment = null, leavesTaken = null) => {
  try {
    const updates = {
      status: status,
      comment: comment,
    };

    await firebaseLib.database().ref(`leaves/${leaveId}`).update(updates);

    if (leavesTaken !== null) {
      const res = await firebaseLib.database().ref(`users/${userId}`).update({
        leavesTaken: leavesTaken,
      });
    }

    await getSingleUser();
    return { message: "Leave updated successfully" };
  } catch (error) {
    console.error("Error updating leave: ", error);
    throw error;
  }
};
const updateUserRole = async (role, userId) => {
  try {
    await firebaseLib.database().ref(`users/${userId}`).update({ role });
  } catch (error) {
    console.error("Error updating role:", error);
    swal("Oops!", "Failed to update role", "error");
  }
};
const sendPasswordResetEmail = async (email , resetUrl) => {
  try {
    const actionCodeSettings = {
      url: resetUrl,
      handleCodeInApp: true,
    };
    
    await firebaseLib.auth().sendPasswordResetEmail(email, actionCodeSettings);
    console.log("Password reset email sent.");
  } catch (error) {
    throw error;
  }
};
async function fetchManualHoursActivities(month, year, userId) {
  try {
    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    const selectMonthNum = months.indexOf(month);
    if (selectMonthNum === -1) {
      console.error("Invalid month provided:", month);
      return [];
    }
    const startTime = new Date(year, selectMonthNum, 1, 0, 0, 0).getTime();
    const endTime = new Date(year, selectMonthNum + 1, 0, 23, 59, 59).getTime();
    const ref = firebaseLib.database().ref("adminActivities");
    let query = ref
      .orderByChild("timestamp")
      .startAt(new Date(startTime).toISOString())
      .endAt(new Date(endTime).toISOString());
    if (userId) {
      query = ref
        .orderByChild("activityOnUser")
        .equalTo(userId);
    }
    const response = await query.once("value");
    const value = response.val();
    const activities = [];
    if (value) {
      Object.keys(value).forEach(key => {
        if (value[key].type === "manual_hours" && (!userId || value[key].activityOnUser === userId)) {
          activities.push({ ...value[key], activityKey: key });
        }
      });
    }
    return activities;
  } catch (error) {
    console.error("Error fetching manual hours activities:", error);
    return [];
  }
}
async function fetchAdminActivities(month, year, userId = null, cardId = null, activityType = null) {
  try {
    const months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    const monthIndex = months.indexOf(month);
    if (monthIndex === -1) return [];

    const startDate = new Date(year, monthIndex, 1);
    const endDate = new Date(year, monthIndex + 1, 0, 23, 59, 59, 999);

    const ref = firebaseLib.database().ref("adminActivities");
    const snapshot = await ref.once("value");
    const data = snapshot.val();
    if (!data) return [];

    const result = [];

    function parseTimestamp(ts) {
      if (!ts || typeof ts !== "string") return null;
      if (ts.includes(", ")) {
        const [datePart, timePartRaw] = ts.split(", ");
        const [d,m,y] = datePart.split("/");
        if (!d || !m || !y) return null;
        const timePart = timePartRaw.toUpperCase().replace(/\s*(AM|PM)$/,' $1');
        const isoStr = `${y}-${m.padStart(2,'0')}-${d.padStart(2,'0')} ${timePart}`;
        const t = new Date(isoStr);
        return isNaN(t) ? null : t.getTime();
      }
      const t = new Date(ts);
      return isNaN(t) ? null : t.getTime();
    }

    Object.keys(data).forEach(key => {
      const act = data[key];

      // Only fetch types other than manual_hours
      if (act.type === "manual_hours") {
        console.log("Skipping manual_hours in universal fetch:", key);
        return;
      }

      if (activityType && (!act.type || act.type.toLowerCase() !== activityType.toLowerCase())) {
        console.log("Skipping due to type mismatch:", key, act.type);
        return;
      }

      if (act.month !== month || String(act.year) !== String(year)) return;

      if (userId && act.activityOnUser !== userId) return;
      if (cardId && act.cardId !== cardId) return;

      const actTime = parseTimestamp(act.timestamp);
      const actDate = actTime ? new Date(actTime) : null;

      result.push({
        activityKey: key,
        ...act,
        readableDate: actDate ? actDate.toLocaleString() : act.timestamp
      });
    });

    result.sort((a,b) => {
      const timeA = parseTimestamp(a.timestamp) || 0;
      const timeB = parseTimestamp(b.timestamp) || 0;
      return timeA - timeB;
    });
    return result;

  } catch (error) {
    console.error("Error fetching universal activities:", error);
    return [];
  }
}
// Wrapper for performance
async function fetchPerformanceActivities(month, year, userId, cardId = null) {
  return await fetchAdminActivities(month, year, userId, cardId, "performance_edit");
}

const ResetPassword = async (oobCode, newPassword) => {
  try {
    await firebaseLib.auth().confirmPasswordReset(oobCode, newPassword);
  } catch (error) {
    throw new Error(error.message);
  }
};

const ResetCode = async (oobCode) => {
  console.log("Starting ResetCode with oobCode:", oobCode);
  try {
    const info = await firebaseLib.auth().verifyPasswordResetCode(oobCode);
    console.log("OOB code verification successful, returned email:", info);
    if (!info) {
      console.error("No email returned from verifyPasswordResetCode");
      throw new Error("Invalid or expired password reset code.");
    }
    return info;
  } catch (error) {
    console.error("Error in ResetCode:", error);
    throw error; 
  }
};

const updateLogTime = async (logKey, updatedTimes) => {
  return firebaseLib.database().ref("timePeriod/" + logKey).update(updatedTimes);
};

async function constants() {
  try {
    const response = await firebaseLib.database().ref("constants").once("value");
    const value = response.val();
    if (!value) {
      console.warn("Constants not found, returning default values");
      return { days: [], totalHours: 0, late: "11:00" };
    }
    console.log("Constants fetched:", value);
    return value;
  } catch (error) {
    console.error("Error fetching constants:", error);
    return { days: [], totalHours: 0, late: "11:00" };
  }
}
 const saveBugReport = async (bugData) => {
  try {
    await firebaseLib.database().ref('bugReported').push(bugData);
  } catch (error) {
    console.error(' Firebase error:', error);
    throw error;
  }
};

const getAllBugReports = async () => {
  try {
    const snapshot = await firebaseLib
      .database()
      .ref('bugReported')
      .once('value');

    if (!snapshot.exists()) return [];

    const data = snapshot.val();

    return Object.keys(data).map(id => ({
      id,
      ...data[id]
    })).reverse();
  } catch (error) {
    console.error('Firebase error:', error);
    throw error;
  }
};

const updateBugStatus = async (bugId, status = 'Resolved') => {
  try {
    await firebaseLib
      .database()
      .ref(`bugReported/${bugId}`)
      .update({
        status,
        updatedAt: Date.now()
      });
  } catch (error) {
    console.error('Firebase error:', error);
    throw error;
  }
};

 const logAdminActivityToDB = async (activityData) => {
  try {
    await firebaseLib.database().ref('adminActivities').push(activityData);
  } catch (error) {
    console.error(' Firebase error:', error);
    throw error;
  }
};
const getAllAdminActivities = async () => {
  try {
    const snapshot = await firebaseLib
      .database()
      .ref('adminActivities')
      .once('value');

    if (!snapshot.exists()) return [];

    return Object.entries(snapshot.val()).map(([id, data]) => ({
      id,
      ...data
    })).reverse();
  } catch (error) {
    console.error('Firebase error:', error);
    throw error;
  }
};

async function fetchTaxSlabs() {
  try {
    const response = await firebaseLib.database().ref("constants/taxSlabs").once("value");
    const value = response.val();
    if (!value) {
      console.warn("Tax slabs not found, returning default values");
    }
    return value;
  } catch (error) {
    console.error("Error fetching tax slabs:", error);
  }
}
async function logPerformanceChange (changeData) {
  try {
    await firebaseLib.database().ref('performanceChanges').push(changeData);
  } catch (error) {
    console.error('Error logging performance change:', error);
    throw error;
  }
};

const fetchEditedCards = async ({ month, year, userId, boardId }) => {
  try {
    const snap = await firebaseLib.database().ref("performance").once("value");
    const data = snap.val() || {};

    return Object.entries(data).reduce((acc, [cardId, doc]) => {
      const match =
        (!month || doc.month === month) &&
        (!year || doc.year === year) &&
        (!userId || doc.user === userId) &&
        (!boardId || doc.board === boardId);

      if (match) acc[cardId] = doc;
      return acc;
    }, {});
  } catch (e) {
    console.error("fetchEditedCards error:", e);
    return {};
  }
};
const addPerformanceItem = async (payload) => {
 const cardId =  firebaseLib.database().ref().push().key;
  if (!cardId) {
    throw new Error("cardId is required");
  }
  const record ={
    ...payload,
    cardId,
    id: cardId
  }
  try {
    await firebaseLib
      .database()
      .ref(`performance/${cardId}`)
      .set(record);
    return cardId;
  } catch (error) {
    console.error(" Failed to save performance card:", error);
    throw error;
  }
};

const saveEditedCard = async (payload) => {
  const { cardId, user, year, month, board, updatedData, originalData, status, 
  isCustom, customEdit, type, reason, ticketStatus } = payload;
  const filterKey = `${year}-${month}-${user}-${board || 'null'}`;

  const record = {
    reason: reason || null,
    type: type || null,
    cardId,
    user,
    year,
    month,
    board: board || null,
    updatedData,
    originalData,
    movedDate: payload.movedDate || null,
    movedTime: payload.movedTime || null,
    filterKey,
    status,
    isCustom: isCustom || null,
    customEdit: customEdit || null,
    ticketStatus: ticketStatus || null,
    timestamp: firebaseLib.database.ServerValue.TIMESTAMP,
  };

  try {
    await firebaseLib.database().ref(`performance/${cardId}`).set(record);
  } catch (error) {
    console.error(`❌ Failed to save card ${cardId}:`, error);
    throw error;
  }
};

const saveApproveReject = async (payload) => {
  const { cardId, updatedData, status } = payload;

  const updates = {
    updatedData,
    status,
    timestamp: firebaseLib.database.ServerValue.TIMESTAMP,
  };

  try {
    await firebaseLib.database()
      .ref(`performance/${cardId}`)
      .update(updates);

    console.log(`Card ${cardId} updated → status: ${status}`);
  } catch (error) {
    console.error(`Failed to update card ${cardId}:`, error);
    throw error;
  }
};

const deleteEditedCard = async (cardId) => {
  try {
    await firebaseLib.database().ref(`performance/${cardId}`).remove();
    console.log(`🗑️ Card ${cardId} deleted successfully.`);
  } catch (error) {
    console.error(`❌ Failed to delete card ${cardId}:`, error);
    throw error;
  }
};
const getAdjustments = async (year = null, month = null, userId = null) => {
  try {
    const query = firebaseLib.database().ref("adjustments");
    const response = await query.once("value");
    const data = response.val();
    if (data) {
      return Object.keys(data)
        .map(key => ({
          id: key,
          ...data[key]
        }))
        .filter(adj => {
          const yearMatch = !year || Number(adj.year) === Number(year);
          const monthMatch = !month || adj.month === month;
          const userMatch = !userId || adj.employeeId === userId;
          return yearMatch && monthMatch && userMatch;
        });
    }
    return [];
  } catch (error) {
    console.error("Error fetching adjustments:", error);
    return [];
  }
};

const postAdjustment = async (data) => {
  try {
    const path = "adjustments";
    if (data.id) {
      // Update existing adjustment
      await firebaseLib.database().ref(`${path}/${data.id}`).update(data);
         swal("Great", "Adjustment updated successfully");
      return { message: "Adjustment updated successfully", id: data.id };
    } else {
      // Create new adjustment
      const newRef = firebaseLib.database().ref(path).push();
      await newRef.set(data);
        swal("Great", "Adjustment created successfully");
      return { message: "Adjustment created successfully", id: newRef.key };
    }
  } catch (error) {
     swal("Error", "Something went wrong!", "error");
    console.error("Error posting adjustment:", error);
    throw error;
  }
};
const deleteAdjustment = async (id) => {
  try {
    const path = `adjustments/${id}`;
    await firebaseLib.database().ref(path).remove();
       swal("Great", "Adjustment deleted successfully");
    return { message: "Adjustment deleted successfully" };
  } catch (error) {
      swal("Error", "Failed to delete adjustment", "error");
    console.error("Error deleting adjustment:", error);
    throw error;
  }
};

const getEmployeeApprovedLeaves = async (employeeId, month, year) => {
    const monthNumber = String(new Date(`${month} 1, ${year}`).getMonth() + 1).padStart(2, '0');

    const leavesRef = firebaseLib.database().ref('leaves')
        .orderByChild('userId')
        .equalTo(employeeId);

    const snapshot = await leavesRef.once('value');
    if (!snapshot.exists()) return [];

    const leaves = Object.values(snapshot.val());

    const approvedLeaves = leaves.filter(leave => {
        if (leave.status !== 'Approved') return false;
        if (!leave.startDate) return false;
        const parts = leave.startDate.split('-');
        return parts[1] === monthNumber && parts[0] === String(year);
    });

    const allLeaveDates = approvedLeaves.flatMap(leave => {
        const start = new Date(leave.startDate);
        const end = new Date(leave.endDate);
        const dates = [];

        for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
            const day = String(d.getDate()).padStart(2, '0');
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const year = d.getFullYear();
            dates.push(`${day}-${month}-${year}`);
        }

        return dates;
    });

    return allLeaveDates;
}

const addHoliday = async (data) => {
  try {
    const newHolidayRef = firebaseLib.database().ref('constants/holidays').push();
    const holidayId = newHolidayRef.key; 

    await newHolidayRef.set({
      ...data,
      uid: holidayId, 
      createdAt: Date.now(),
    });

    return { success: true, uid: holidayId }; 
  } catch (error) {
    console.error("Error adding holiday: ", error);
    swal("Oops!", error.message || "Failed to add holiday", "error");
  }
};

const getAllHolidays = async () => {
  try {
    const snapshot = await firebaseLib.database().ref('constants/holidays').once('value');
    const holidaysObj = snapshot.val() || {};
    return Object.keys(holidaysObj).map(key => holidaysObj[key]);
  } catch (error) {
    console.error("Error fetching holidays: ", error);
    swal("Oops!", error.message || "Failed to fetch holidays", "error");
    return [];
  }
};

const updateHoliday = async (uid, data) => {
  try {
    if (!uid) throw new Error("Holiday ID is required");

    await firebaseLib.database().ref(`constants/holidays/${uid}`).update({
      ...data,
      updatedAt: Date.now(),
    });

    return { success: true };
  } catch (error) {
    console.error("Error updating holiday: ", error);
    swal("Oops!", error.message || "Failed to update holiday", "error");
  }
};

const deleteHoliday = async (uid) => {
  try {
    if (!uid) throw new Error("Holiday ID is required");

    await firebaseLib.database().ref(`constants/holidays/${uid}`).remove();
    return { success: true };
  } catch (error) {
    console.error("Error deleting holiday: ", error);
    swal("Oops!", error.message || "Failed to delete holiday", "error");
  }
};

const saveTrelloUser = async(userId, username)=> {
 return await firebaseLib.database().ref(`users/${userId}`).update({
    trelloUsername: username
  });
}

const isPayrollProcessed = async (year, month, employeeId) => {
  try {
    const ref = firebaseLib
      .database()
      .ref(`payroll/${year}/${month}`)
      .orderByChild("employeeId")
      .equalTo(employeeId);
    const snapshot = await ref.once("value");
    if (!snapshot.exists()) {
      return false;
    }
    const data = snapshot.val();
    for (const key in data) {
      if (data[key].status === "Processed") {
        return true;
      }
    }
    return false;
  } catch (error) {
    console.error("Payroll fetch failed:", error);
    return false;
  }
};

const ApproveNewTicket = async (ticketId, ticketStatus) => {
  try {
    await firebaseLib.database().ref(`performance/${ticketId}`).update({ ticketStatus : "approved" });
  } catch (error) {
    console.error("Error updating ticket status:", error);
    swal("Oops!", "Failed to update ticket status", "error");
  }
}

const fetchPerformanceLock = async (year, month) => {
  try {
    const key = `${year}_${month}`; 
    const ref = firebaseLib.database().ref(`performance_locks/${key}`);
    
    const snap = await ref.once('value');
    const data = snap.val() || {};
    return { locked: data.locked || false, scheduledLockTime: data.scheduledLockTime || null, userIds: data.userIds || {}};
  } catch (error) {
    console.error("Error fetching performance lock:", error);
    throw error;
  }
};

const savePerformanceLock = async (year, month, locked, scheduledTime = null) => {
  try {
    const key = `${year}_${month}`;
    const ref = firebaseLib.database().ref(`performance_locks/${key}`);

    const data = {
      locked,
      scheduledLockTime: scheduledTime,
    };

    await ref.update(data);
  } catch (error) {
    console.error("Error saving performance lock:", error);
    throw error;
  }
};

const removeUserFromLock = async (year, month, userId) => {
  try {
    const lockKey = `${year}_${month}`;
    const lockRef = firebaseLib
      .database()
      .ref(`performance_locks/${lockKey}/userIds/${userId}`);

    await lockRef.remove();

    return true;
  } catch (error) {
    console.error("Failed to remove userId:", error);
    throw error;
  }
};

const savePerformanceSnapshot = async (snapshotArray) => {
  try {
    for (const card of snapshotArray) {
      const cardId = card.cardId || card.id;
      if (!cardId) continue;
      await firebaseLib
        .database()
        .ref(`performance/${cardId}`)
        .set(card);
    }
    return true;
  } catch (error) {
    console.error("Failed to save performance snapshot:", error);
    throw error;
  }
};

const savePerformanceUserId = async (year, month, userId) => {
  try {
    const lockKey = `${year}_${month}`;
    const lockRef = firebaseLib.database().ref(`performance_locks/${lockKey}/userIds`);
    const snap = await lockRef.once('value');
    const currentUserIds = snap.val() || {};
    currentUserIds[userId] = true;
    await lockRef.set(currentUserIds);
    return true;
  } catch (error) {
    console.error("Failed to save performance user ID:", error);
    throw error;
  }
};

const updatePerformanceLockUserFlag = async (year, month, userId, isSaved) => {
  try {
    const key = `${year}_${month}`;
    const lockRef = firebaseLib.database().ref(`performance_locks/${key}/userIds`);
    const snap = await lockRef.once('value');
    const currentUserIds = snap.val() || {};
    currentUserIds[userId] = isSaved;
    await lockRef.set(currentUserIds);
    return true;
  } catch (error) {
    console.error("Failed to update user lock flag:", error);
    throw error;
  }
};

const addPerformanceCriteria = async (data) => {
  try {
    const newCriteriaRef = firebaseLib.database().ref('constants/performanceCriteria').push();
    const criteriaId = newCriteriaRef.key;
    await newCriteriaRef.set({
      ...data,
      uid: criteriaId,
      createdAt: Date.now(),
    });
    return { success: true, uid: criteriaId };
  } catch (error) {
    console.error("Error adding performance criteria: ", error);
    swal("Oops!", error.message || "Failed to add performance criteria", "error");
  }
};

const getAllPerformanceCriteria = async () => {
  try {
    const snapshot = await firebaseLib.database().ref('constants/performanceCriteria').once('value');
    const criteriaObj = snapshot.val() || {};
    return Object.keys(criteriaObj).map(key => criteriaObj[key]);
  } catch (error) {
    console.error("Error fetching performance criteria: ", error);
    swal("Oops!", error.message || "Failed to fetch performance criteria", "error");
    return [];
  }
};

const updatePerformanceCriteria = async (uid, data) => {
  try {
    if (!uid) throw new Error("Performance criteria ID is required");
    await firebaseLib.database().ref(`constants/performanceCriteria/${uid}`).update({
      ...data,
      updatedAt: Date.now(),
    });
    return { success: true };
  } catch (error) {
    console.error("Error updating performance criteria: ", error);
    swal("Oops!", error.message || "Failed to update performance criteria", "error");
  }
};

const deletePerformanceCriteria = async (uid) => {
  try {
    if (!uid) throw new Error("Performance criteria ID is required");
    await firebaseLib.database().ref(`constants/performanceCriteria/${uid}`).remove();
    return { success: true };
  } catch (error) {
    console.error("Error deleting performance criteria: ", error);
    swal("Oops!", error.message || "Failed to delete performance criteria", "error");
  }
};

const addPerformanceScoreByGrade = async (data) => {
  try {
    const newRef = firebaseLib.database().ref('constants/performanceScoresByGrade').push();
    const scoreId = newRef.key;

    await newRef.set({
      ...data,
      uid: scoreId,
      createdAt: Date.now(),
    });

    return { success: true, uid: scoreId };
  } catch (error) {
    console.error("Error adding performance score by grade: ", error);
    swal("Oops!", error.message || "Failed to add target score", "error");
    throw error;
  }
};

const getAllPerformanceScoresByGrade = async () => {
  try {
    const snapshot = await firebaseLib.database().ref('constants/performanceScoresByGrade').once('value');
    const scoresObj = snapshot.val() || {};
    return Object.keys(scoresObj).map(key => scoresObj[key]);
  } catch (error) {
    console.error("Error fetching performance scores by grade: ", error);
    swal("Oops!", error.message || "Failed to fetch target scores", "error");
    return [];
  }
};

const updatePerformanceScoreByGrade = async (uid, data) => {
  try {
    if (!uid) throw new Error("Score ID (uid) is required");

    await firebaseLib.database().ref(`constants/performanceScoresByGrade/${uid}`).update({
      ...data,
      updatedAt: Date.now(),
    });

    return { success: true };
  } catch (error) {
    console.error("Error updating performance score by grade: ", error);
    swal("Oops!", error.message || "Failed to update target score", "error");
    throw error;
  }
};

const deletePerformanceScoreByGrade = async (uid) => {
  try {
    if (!uid) throw new Error("Score ID (uid) is required");

    await firebaseLib.database().ref(`constants/performanceScoresByGrade/${uid}`).remove();
    return { success: true };
  } catch (error) {
    console.error("Error deleting performance score by grade: ", error);
    swal("Oops!", error.message || "Failed to delete target score", "error");
    throw error;
  }
};

const firebase = {
  deletePromotionInfo,
  getEmailTemplates,
  addEmailTemplate,
  updateEmailTemplate,
  getEmployeeApprovedLeaves,
  addHoliday,
  getAllHolidays,
  updateHoliday,
  deleteHoliday,
  ResetCode,
  ResetPassword,
  sendPasswordResetEmail,
  checkAlreadyConfiguredApp,
  configuredAppForReportBug,
  updateUserActiveStatus,
  createOrUpdateQuarterlyMeetingDetails,
  createOrUpdateIncrementMeetingDetails,
  deleteQuarterlyMeetingDetails,
  deleteIncrementMeetingDetails,
  updateEmployee,
  configureFirebase,
  unconfigureFirebase,
  login,
  fetchAllUsersRealTime,
  readDatabase,
  updateDatabase,
  uploadImage,
  reAuthenticateUserFirebase,
  updatePasswordFirebase,
  logout,
  submitLeave,
  getSingleUser,
  updateLeaveStatusAndComment,
  fetchCompanyData,
  deleteEmployee,
  addEmployee,
  updateLogTime,
  pushDatabase,
  updateUserRole,
  fetchManualHoursActivities,
  fetchPerformanceActivities,
  constants,
  saveBugReport,
  getAllBugReports,
  updateBugStatus,
  logAdminActivityToDB,
  getAllAdminActivities,
  fetchTaxSlabs,
  updateUserStatus,
  updateUserResignationDate,
  updateUserLeaves,
  updateUserPreviousStatus,
  logPerformanceChange,
  fetchEditedCards,
  saveEditedCard,
  deleteEditedCard,
  postAdjustment,
  getAdjustments,
  deleteAdjustment,
  saveApproveReject,
  saveTrelloUser,
  isPayrollProcessed,
  addPerformanceItem,
  ApproveNewTicket,
  fetchPerformanceLock,
  savePerformanceLock,
  addPerformanceCriteria,
  getAllPerformanceCriteria,
  updatePerformanceCriteria,
  deletePerformanceCriteria,
  savePerformanceSnapshot,
  savePerformanceUserId,
  updatePerformanceLockUserFlag,
  removeUserFromLock,
  addPerformanceScoreByGrade,
  getAllPerformanceScoresByGrade,
  updatePerformanceScoreByGrade,
  deletePerformanceScoreByGrade


};

export default firebase;



// WEBPACK FOOTER //
// ./src/assets/config/firebase.js